import { Category } from '@shared/interfaces/Category'
import { tagTheme } from '@taglivros/tag-components'
import { Page } from './Pages'

interface ColorsType {
  BUTTON_BACKGROUND: keyof typeof tagTheme.cores
  BUTTON_HOVER: keyof typeof tagTheme.cores
  BUTTON_COLOR: keyof typeof tagTheme.cores
}

interface Colors {
  SOLID?: ColorsType
  OUTLINE?: ColorsType
  TITLE?: keyof typeof tagTheme.cores
  DEFAULT?: keyof typeof tagTheme.cores
  SELECTED?: keyof typeof tagTheme.cores
  PRIMARY?: keyof typeof tagTheme.cores
}

export const colors: Record<Category.Type | Page, Colors> = {
  'curadoria': {
    'SOLID': {
      'BUTTON_BACKGROUND': 'TAG1-700',
      'BUTTON_HOVER': 'TAG1-800',
      'BUTTON_COLOR': 'WHITE',
    },
    'OUTLINE': {
      'BUTTON_BACKGROUND': 'WHITE',
      'BUTTON_HOVER': 'TAG1-100',
      'BUTTON_COLOR': 'TAG1-700',
    },
    'TITLE': 'TAG1-600',
    'DEFAULT': 'TAG1-700',
    'SELECTED': 'TAG1-100',
    'PRIMARY': 'TAG1-400',
  },
  'ineditos': {
    'SOLID': {
      'BUTTON_BACKGROUND': 'TAG2-650-TXT',
      'BUTTON_HOVER': 'TAG2-700',
      'BUTTON_COLOR': 'WHITE',
    },
    'OUTLINE': {
      'BUTTON_BACKGROUND': 'WHITE',
      'BUTTON_HOVER': 'TAG2-100',
      'BUTTON_COLOR': 'TAG2-650-TXT',
    },
    'TITLE': 'TAG2-650-TXT',
    'DEFAULT': 'TAG2-650-TXT',
    'SELECTED': 'TAG2-100',
    'PRIMARY': 'TAG2-500',
  },
  'home': {
    'SOLID': {
      'BUTTON_BACKGROUND': 'TAG1-700',
      'BUTTON_HOVER': 'TAG1-800',
      'BUTTON_COLOR': 'WHITE',
    },
    'SELECTED': 'TAG2-100',
    'PRIMARY': 'TAG2-500',
  },
}
